import { Outlet } from 'react-router';
import { useAuth } from '@/contexts/AuthContext';
import { BootSplash } from '@/components/BootSplash';
import { CrossHostNavigate } from '@/components/CrossHostNavigate';

export function AdminGuard() {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return <BootSplash />;
  }

  if (!isAuthenticated) {
    // Use the legacy /admin/login path: canonicalUrl strips /admin in prod
    // (target = https://admin.velko-pos.com/login) and preserves it in local
    // dev (target = http://localhost:8080/admin/login). CrossHostNavigate
    // resolves both into the right Navigate target.
    return <CrossHostNavigate to="/admin/login" />;
  }

  if (!isAdmin) {
    return <CrossHostNavigate to="/owner/dashboard" />;
  }

  return <Outlet />;
}
